import { render, staticRenderFns } from "./qna_zoom.vue?vue&type=template&id=68ae827c&scoped=true&"
import script from "./qna_zoom.vue?vue&type=script&lang=js&"
export * from "./qna_zoom.vue?vue&type=script&lang=js&"
import style0 from "./qna_zoom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./qna_zoom.vue?vue&type=style&index=1&id=68ae827c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae827c",
  null
  
)

export default component.exports